import React from 'react';
import styled from 'styled-components';
import PermissionRedirect from '../../components/PermissionRedirect';
import { IoIosArrowBack } from 'react-icons/io';
import { useNavigate } from 'react-router';

const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.whiteColor};
`;

const Title = styled.h1`
  position: relative;
  padding: 30px 0px;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: ${({ theme }) => theme.colors.whiteColor};
  background-color: #d3e8e0;
  @media (max-width: 768px) {
    padding: 20px 0px;
    font-size: 20px;
  }
`;
const Icon = styled.div`
  position: absolute;
  left: 20px;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px;
  @media (max-width: 768px) {
    padding: 20px;
    gap: 10px;
  }
`;
const Desc = styled.div`
  word-break: keep-all;
  font-size: 16px;
  line-height: 26px;
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

const SubTitle = styled.h1`
  word-break: keep-all;
  font-size: 16px;
  line-height: 26px;
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

const SubDesc = styled.ul`
  padding-left: 16px;
  word-break: keep-all;
  font-size: 16px;
  line-height: 26px;
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
    padding-left: 10px;
  }
`;

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <PermissionRedirect />
      <Title>
        <Icon onClick={() => navigate(-1)}>
          <IoIosArrowBack />
        </Icon>
        개인정보처리 취급방침
      </Title>
      <Content>
        <Desc>
          '(주)포엔'은 (이하 '회사'는) 고객님의 개인정보를 중요시하며, "개인정보
          보호법 및 관련 법령“을 준수하고 있습니다. <br />
          회사는 개인정보처리방침을 통하여 고객님께서 제공하시는 개인정보가
          어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한
          조치가 취해지고 있는지 알려드립니다. <br />
          회사의 개인정보처리방침은 다음과 같은 내용을 담고 있습니다.
        </Desc>
        <Desc>
          (1) 수집하는 개인정보의 항목 및 수집방법 <br />
          (2) 개인정보의 수집 및 이용목적 <br />
          (3) 개인정보의 보유 및 이용기간 <br />
          (4) 개인정보의 처리위탁 <br />
          (5) 개인정보 파기절차 및 방법 <br />
          (6) 이용자의 권리와 그 행사방법 <br />
          (7) 개인정보의 기술적/관리적 보호 대책
          <br />
          (8) 개인정보보호책임자 및 담당자의 연락처
        </Desc>
        <Desc>
          <SubTitle>(1) 수집하는 개인정보의 항목 및 수집방법</SubTitle>
          <SubDesc>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>
                수집항목: 사용자 구분(구매자, 판매자), 이름, 아이디, 비밀번호,
                전화번호, 주소, 이메일 주소, 사업자등록번호, 대표자명, 사업장명,
                개업일자, 사업장 주소, 계좌번호
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>
                개인정보 수집 방법: 서비스 이용 <br />
                회사는 이용자의 소중한 인권을 침해할 우려가 있는 민감한
                정보(인종, 사상 및 신조, 정치적성향 이나 범죄기록, 의료정보
                등)는 어떠한 경우에도 수집하지 않으며, 만약 법령에서 정한 의무에
                따라 불가피하게 수집하는 경우 에는 반드시 이용자에게 사전 동의를
                거치겠습니다. 다만, 해당 정보는 이용자가 확인한 시점을 기준으로
                한 정보이며, 이용자의 개인정보를 추가 수집하는 경우에는 반드시
                사전에 이용자에게 해당 사실을 알리고 동의를 거치겠습니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>(2) 개인정보의 수집 및 이용목적</SubTitle>
          <SubDesc>
            <li>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>
                회원관리
                <br /> 회원제 서비스 이용 및 제한적 본인 확인제에 따른 본인확인,
                개인식별, 불량회원의 부정 이용방지와 비인가 사용방지, 가입의사
                확인, 가입 및 가입횟수 제한, 분쟁 조정을 위한 기록보존, 불만처리
                등 민원처리, 고지사항 전달
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>
                마케팅 및 광고에 활용
                <br /> 신규 서비스(제품) 개발 및 특화 , 이벤트 등 광고성 정보
                전달 , 접속 빈도 파악 또는 회원의 서비스, 이용에 대한 통계
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>(3) 개인정보의 보유 및 이용기간</SubTitle>
          <SubDesc>
            <li>
              회사는 이용자가 회원으로서 서비스를 이용하는 동안 이용자의
              개인정보를 보유 및 이용 하며, 이용자가 회원탈퇴를 요청한 경우나
              개인정보의 수집 및 이용목적을 달성하거나 보유 및 이용기간이 종료한
              경우 또는 사업폐지 등의 사유가 발생한 경우 해당 정보를 지체 없이
              파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간
              동안 보존 합니다.
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>
                계약 또는 청약철회 등에 관한 기록
                <br /> 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                <br />
                보존 기간 : 5년
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>
                소비자의 불만 또는 분쟁처리에 관한 기록
                <br /> 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                <br />
                보존 기간 : 3년
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>
                본인확인에 관한 기록
                <br /> 보존 이유 : 정보통신 이용촉진 및 정보보호 등에 관한 법률
                <br />
                보존 기간 : 6개월
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>(4) 개인정보의 처리위탁 및 제3자 제공</SubTitle>
          <SubDesc>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>1)</span>
              <span>
                처리위탁
                <br /> ※ 위탁업체가 변경 될 경우, 변경된 내용은
                개인정보처리방침을 통해 사전 공지하겠습니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>2)</span>
              <span>
                제3자 제공
                <br /> 현재 회사는 이용자의 개인정보를 제3자에게 제공하지
                않습니다. 다만, 법률에 따라 요청이 있을 경우나 이용자의 명시적
                동의가 있는 경우에 한해 제공될 수 있습니다. 이 경우 제공받는 자,
                제공 목적, 항목, 보유 기간 등을 이용자에게 사전 안내하고 동의를
                받습니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>(5) 개인정보 파기절차 및 방법</SubTitle>
          <SubDesc>
            <li>
              회사는 다른 법률에 따라 개인정보를 보존하여야 하는 경우가 아닌 한,
              수집한 이용자의 개인정보의 수집 및 이용목적이 달성되거나, 이용자가
              회원탈퇴를 요청한 경우 지체 없이 파기하여 향후 어떠한 용도로도
              열람 또는 이용할 수 없도록 처리합니다.
              <br />
              단, “3.개인정보의 보유 및 이용기간”과 같은 예외 경우를 두고
              있습니다. <br /> 회사의 개인정보 파기절차 및 방법은 다음과
              같습니다.
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>
                파기절차
                <br /> 이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된
                후 별도의 DB로 옮겨져 (종이의 경우 별도의 서류함) 내부 방침 및
                기타 관련 법령에 의한 정보보호 사유에 따라 (3. 보유 및 이용기간
                참조)일정 기간 저장된 후 파기됩니다. 동 개인정보는 법률에 의한
                경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지
                않습니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>
                파기방법
                <br /> 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는
                기술적 방법을 사용하여 삭제합니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>(6) 이용자의 권리와 그 행사방법</SubTitle>
          <SubDesc>
            <li>
              이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하고 삭제할
              수 있습니다. 다만, 그러한 경우 해당 서비스의 일부 또는 전부 이용이
              어려울 수 있습니다.
              <br /> 이용자는 언제든지 개인정보 제공에 관한 동의 철회를 요청할
              수 있습니다.
              <br /> 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는
              정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지
              않습니다.
              <br /> 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정
              처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록
              하겠습니다.
              <br /> 이용자의 가입해지(동의철회)를 위해서는 ’회원탈퇴’를
              클릭하여 본인 확인 절차를 거치 신 후 직접 열람, 정정 또는 탈퇴가
              가능합니다.
              <br /> 혹은 개인정보보호책임자에게 서면, 전화 또는 이메일로
              연락하시면 지체 없이 조치하겠습니다.
              <br /> 회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는
              삭제된 개인정보는 "3. 개인정보의 보유 및 이용기간"에 명시된 바에
              따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고
              있습니다.
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>(7) 개인정보의 기술적/관리적 보호 대책</SubTitle>
          <SubDesc>
            <li>
              회사는 이용자들의 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지
              않도록 안전성을 확보하기 위해 다음과 같은 조치를 취하고 있습니다.
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>
                개인정보 암호화
                <br /> 이용자의 비밀번호는 암호화하여 저장하고 있으며, 파일 및
                전송데이터를 암호화하여 혹시 발생할 수 있는 사고 시라도 이용자의
                개인정보가 유출되지 않도록 관리되고 있습니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>
                접속 기록 관리 및 보관
                <br /> 개인정보처리시스템의 접속 기록을 최소 1년 이상 보관하며,
                위ㆍ변조 방지를 위한 보안 기술을 적용하고 있습니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>
                내부 보안 점검 및 외부 침입 방지
                <br /> 회사는 개인정보의 안전한 처리를 위해 주기적으로 시스템
                설정을 검토하며, 무단 접근을 방지하기 위해 접근 권한을 엄격히
                관리하고 있습니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>
                개인정보 접근 제한
                <br /> 개인정보에 대한 접근 권한은 최소한으로 부여하며, 권한
                관리 체계를 통해 무단 접근을 방지하고 있습니다. 이용자 본인의
                부주의나 인터넷상의 문제로 ID, 비밀번호, 전화번호 등 개인정보가
                유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지 않습니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>(8) 개인정보보호책임자 및 담당자의 연락처</SubTitle>
          <SubDesc>
            <li>
              회사는 개인정보에 대한 의견수렴 및 불만처리를 담당하는 개인정보
              보호책임자 및 담당자를 지정하고 있고, 연락처는 아래와 같습니다.
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>개인정보관리책임자 성명 : 김우재</span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>직책 : 매니저</span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>전화번호 : 070-7797-8423</span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>-</span>
              <span>이메일 : wjkim@poen.co.kr</span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련
          민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는
          이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.
          <br /> 기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래
          기관에 문의하시기 바랍니다.
        </Desc>
        <Desc>
          <li style={{ display: 'flex', gap: 5 }}>
            <span>-</span>
            <span>
              개인분쟁조정위원회 ( https://www.kopico.go.kr / 1833-6972 )
            </span>
          </li>
          <li style={{ display: 'flex', gap: 5 }}>
            <span>-</span>
            <span>
              정보보호마크인증위원회 ( https://www.eprivacy.or.kr /
              02-550-9532~4 )
            </span>
          </li>
          <li style={{ display: 'flex', gap: 5 }}>
            <span>-</span>
            <span>
              대검찰청 인터넷범죄수사센터 ( https://www.spo.go.kr / 1301 )
            </span>
          </li>
          <li style={{ display: 'flex', gap: 5 }}>
            <span>-</span>
            <span>
              경찰청 사이버테러대응센터 ( https://ecrm.police.go.kr /
              02-3150-2659 )
            </span>
          </li>
        </Desc>
      </Content>
    </Container>
  );
};

export default PrivacyPolicyPage;
